import { render, staticRenderFns } from "./EighthSection.vue?vue&type=template&id=15ea3fdc&scoped=true&"
import script from "./EighthSection.vue?vue&type=script&lang=js&"
export * from "./EighthSection.vue?vue&type=script&lang=js&"
import style0 from "./EighthSection.vue?vue&type=style&index=0&id=15ea3fdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ea3fdc",
  null
  
)

export default component.exports